import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IProgramAssistantActions, IThunkOnGetProgramAssistants } from '../types';
import isProgramAssistantAssignedToTeam from '../utils/isProgramAssistantAssignedToTeam';

const TEAM_FILTER_FETCH_PAGE_SIZE = 5000;

const onGetProgramAssistants: IThunkOnGetProgramAssistants = thunk(
  async ({ setProgramAssistants }: Actions<IProgramAssistantActions>, payload) => {
    const { clinicId, params, filterByTeamId } = payload;

    const fetchParams =
      filterByTeamId != null
        ? { ...params, pageNumber: 1, pageSize: TEAM_FILTER_FETCH_PAGE_SIZE }
        : params;

    const {
      data: { total, items },
    } = await api.programAssistant.getProgramAssistants(clinicId, fetchParams);

    if (!filterByTeamId) {
      setProgramAssistants({ items, pagination: { ...params, total } });
      return;
    }

    const filteredItems = items.filter(item =>
      isProgramAssistantAssignedToTeam(item, filterByTeamId),
    );
    const pageNumber = params?.pageNumber || 1;
    const pageSize = params?.pageSize || 25;
    const start = (pageNumber - 1) * pageSize;
    const paginatedItems = filteredItems.slice(start, start + pageSize);

    setProgramAssistants({
      items: paginatedItems,
      pagination: { ...params, total: filteredItems.length },
    });
  },
);

export default onGetProgramAssistants;
